<mat-card class="cardT peso-titulo">
  <span>Controle de Peso</span>

  <span class="peso-acoes">
    <button
      mat-icon-button
      type="button"
      matTooltip="Calendário"
      [class.peso-acao--ativa]="modo === 'calendario'"
      [disabled]="modo === 'calendario'"
      (click)="exibirModo('calendario')">
      <mat-icon>calendar_today</mat-icon>
    </button>

    <button
      mat-icon-button
      type="button"
      matTooltip="Lista"
      [class.peso-acao--ativa]="modo === 'lista'"
      [disabled]="modo === 'lista'"
      (click)="exibirModo('lista')">
      <mat-icon>list_alt</mat-icon>
    </button>

    <button
      mat-icon-button
      type="button"
      matTooltip="Gráfico"
      [class.peso-acao--ativa]="modo === 'grafico'"
      [disabled]="modo === 'grafico'"
      (click)="exibirModo('grafico')">
      <mat-icon>show_chart</mat-icon>
    </button>

    <button mat-icon-button type="button" matTooltip="Informar altura" (click)="informarAltura()">
      <mat-icon>straighten</mat-icon>
    </button>
  </span>
</mat-card>

<app-lista-dados
  *ngIf="modo === 'lista'"
  [upTitulo]="'Registros de peso'"
  [upIcone]="'monitor_heart'"
  [upCor]="'1565C0'"
  [upDados]="pesos"
  [upColunas]="colunas"
  [upHabilitaEditarLinha]="true"
  [upLargura]="1"
  [upHabilitaContador]="true"
  (ueIniciarEdicaoLinha)="iniciarLinha($event)"
  (ueSalvarLinha)="salvarLinha($event)"
  (ueBotaoExcluir)="excluir($event)">
</app-lista-dados>

<mat-card *ngIf="modo === 'grafico'" class="peso-card">
  <div class="peso-grafico-cabecalho">
    <div class="peso-grafico-titulo">Evolução</div>
    <button mat-icon-button type="button" matTooltip="Baixar imagem" (click)="baixarImagem()">
      <mat-icon>download</mat-icon>
    </button>
    <button mat-icon-button type="button" matTooltip="Baixar calendário" (click)="baixarImagemCalendario()">
      <mat-icon>calendar_view_month</mat-icon>
    </button>
    <button mat-icon-button type="button" matTooltip="Baixar relatório completo" (click)="baixarImagemRelatorioCompleto()">
      <mat-icon>insights</mat-icon>
    </button>
  </div>

  <apx-chart
    [series]="chartSeries"
    [chart]="chart"
    [xaxis]="chartXaxis"
    [yaxis]="chartYaxis"
    [grid]="chartGrid"
    [stroke]="chartStroke"
    [markers]="chartMarkers"
    [colors]="chartColors"
    [dataLabels]="chartDataLabels">
  </apx-chart>
</mat-card>

<app-calendario *ngIf="modo === 'calendario'" [titulo]="tituloMes" [diasDaSemana]="semanas" (mudarMes)="mudarMes($event)">

    <div
      class="calendario-dia peso-dia"
      *ngFor="let dia of dias; trackBy: rastrearDia"
      [class.peso-dia--outro]="dia.getMonth() !== mes.getMonth()"
      [class.peso-dia--selecionado]="chaveDiaEdicao === chave(dia)"
      (click)="iniciarNovo(dia)">
      <div class="calendario-dia__cabecalho"><span class="calendario-dia__numero">{{ dia.getDate() }}</span></div>

      <button
        *ngIf="pesoDoDia(dia) as peso"
        class="peso-tag"
        (click)="editar(peso, $event)">
        {{ peso.vlPeso | number:'1.0-2' }} kg
      </button>

      <div
        *ngIf="chaveDiaEdicao === chave(dia) && editando"
        class="peso-balao"
        [class.peso-balao--direita]="dia.getDay() > 3"
        [class.peso-balao--acima]="abrirBalaoParaCima(dia)"
        (click)="$event.stopPropagation()">
        <strong>{{ editando.id ? 'Editar peso' : 'Novo peso' }}</strong>

        <mat-form-field appearance="fill">
          <mat-label>Data</mat-label>
          <input matInput [matDatepicker]="picker" [max]="hoje" [(ngModel)]="editando.dtPesoData">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Peso (kg)</mat-label>
          <input matInput type="number" min="0" max="300" step="0.01" [(ngModel)]="editando.vlPeso">
        </mat-form-field>

        <div>
          <button mat-button (click)="$event.stopPropagation(); cancelar()">Cancelar</button>
          <button
            *ngIf="editando.id"
            mat-button
            color="warn"
            (click)="$event.stopPropagation(); excluir()">
            Excluir
          </button>
          <button mat-raised-button color="primary" (click)="$event.stopPropagation(); salvar()">
            Salvar
          </button>
        </div>
      </div>
    </div>
</app-calendario>
